import {
    DocumentSnapshot,
    collection, doc, getDoc, getDocs,
    query} from "firebase/firestore";
import { db } from "../firebase";
import { Puzzle, levelConverter } from "../models/Puzzle";
import { Era } from "../models/era";
import { Country } from "../models/country";

export const getAllPuzzles = (async () => {
    const data: DocumentSnapshot[] = [];

    const dataRef = collection(db, "puzzles");
    const q = query(dataRef);

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
        const c = doc.data();
        if (!c.deleted) {
            data.push(doc);
        }
    });

    let promises = data.map(async (doc: DocumentSnapshot) => {
        const course = levelConverter.fromFirestore(doc, {});
        return course;
    });

    return await Promise.all(promises);
})

export const getPuzzle = (async (id?: string): Promise<Puzzle | null> => {
    if (id) {
        const ref = doc(db, "puzzles", id);
        let res = await getDoc(ref);

        let level: Puzzle | null = null;

        if (res.exists()) {
            level = levelConverter.fromFirestore(res, {});
            return level;
        }
    }

    return null;
})

export const getAllEras = (async (): Promise<Era[] | []> => {
    return [];
})

export const getAllCountries = (async (): Promise<Country[] | []> => {
    return [];
})